module.exports = __webpack_public_path__ + "static/img/partner-logo12.da61bcd3.png";